import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Flame, ArrowRight } from 'lucide-react';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 24,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let s = prev.seconds - 1;
        let m = prev.minutes;
        let h = prev.hours;
        if (s < 0) {
          s = 59;
          m -= 1;
        }
        if (m < 0) {
          m = 59;
          h -= 1;
        }
        return {
          hours: h,
          minutes: m,
          seconds: s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const Unit = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-269">
      <div className="bg-brand-dark border border-brand-red/40 rounded-md w-10 h-10 md:w-12 md:h-12 flex items-center justify-center text-lg md:text-2xl font-serif font-bold text-white tabular-nums" data-id="element-270">
        {fmt(value)}
      </div>
      <span className="text-[8px] md:text-[10px] text-gray-400 mt-1 uppercase tracking-wider" data-id="element-271">
        {label}
      </span>
    </div>;
  return <section className="py-6 md:py-8" data-id="element-272">
      <div className="max-w-5xl mx-auto px-4 md:px-6" data-id="element-273">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative overflow-hidden rounded-2xl border border-brand-red/40 bg-brand-red/10 px-4 py-5 md:px-8 md:py-6" data-id="element-274">
          {/* glow */}
          <div className="absolute -right-10 -top-10 w-48 h-48 bg-brand-red/20 rounded-full blur-3xl pointer-events-none" data-id="element-275" />

          <div className="relative flex flex-col md:flex-row items-center gap-4 md:gap-6 text-center md:text-left" data-id="element-276">
            <div className="flex-shrink-0 w-12 h-12 md:w-14 md:h-14 rounded-full bg-brand-red/20 border border-brand-red/40 flex items-center justify-center" data-id="element-277">
              <Flame className="w-6 h-6 md:w-7 md:h-7 text-brand-red" data-id="element-278" />
            </div>

            <div className="flex-1 min-w-0" data-id="element-279">
              <p className="text-brand-red font-bold tracking-widest uppercase text-[10px] md:text-xs mb-1" data-id="element-280">
                Oferta de lanzamiento por tiempo limitado
              </p>
              <h3 className="text-lg md:text-2xl font-serif font-bold text-white leading-tight" data-id="element-281">
                El precio sube cuando termine la cuenta regresiva
              </h3>
              <p className="text-xs md:text-sm text-gray-300 mt-1" data-id="element-282">
                Asegurá tu copia ahora y empezá a cocinar este mismo fin de
                semana.
              </p>
            </div>

            <div className="flex items-center gap-2 md:gap-3" data-id="element-283">
              <Unit value={timeLeft.hours} label="Horas" data-id="element-284" />
              <span className="text-brand-red font-bold text-lg md:text-xl -mt-3" data-id="element-285">
                :
              </span>
              <Unit value={timeLeft.minutes} label="Min" data-id="element-286" />
              <span className="text-brand-red font-bold text-lg md:text-xl -mt-3" data-id="element-287">
                :
              </span>
              <Unit value={timeLeft.seconds} label="Seg" data-id="element-288" />
            </div>

            <motion.button whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} onClick={scrollToPricing} className="flex-shrink-0 w-full md:w-auto inline-flex items-center justify-center gap-2 bg-brand-red hover:bg-brand-redDark text-white font-bold py-3 px-6 rounded-xl shadow-[0_0_20px_rgba(192,57,43,0.4)] transition-colors text-sm md:text-base" data-id="element-289">
              Quiero la oferta
              <ArrowRight className="w-4 h-4" data-id="element-290" />
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>;
}